import defaultTheme from "@/themes/theme";

export const styles = {
  stack: {
    [defaultTheme.breakpoints.down("md")]: {
      top: 54,
      width: "calc(100% - 80px)",
    },
    height: 70,
    ml: "80px",
    width: "calc(100% - 80px)",
    position: "absolute",
    top: 0,
    px: 1.5,
    py: 1,
    zIndex: 34,
    pointerEvents: "none",
    "& .MuiButtonBase-root:not(.Mui-disabled)": {
      pointerEvents: "auto",
    },
  },
};
